import { Link } from "react-router-dom";

function SuccessMsgDiv(props) {
    return (
      <>
        <div className={props.class}>
          { props.returnurl !== undefined ? 
            <Link to={props.returnurl} >
              <p>{props.msg}</p>
            </Link>
            :
            <p>{props.msg}</p>
          }
        </div>
      </>
    );
  }
  
export default SuccessMsgDiv;